<template>
  <b-modal id="auth-info-modal" ref="modal" hide-footer centered no-stacking>
    <template slot="modal-header">
      <div class="m-modal-header">
        <h2 class="top-title mb-0">中意网供应商认证申请</h2>
        <img
          src="@/assets/images/icon_modal_close.png"
          alt
          class="close-button"
          @click.stop="hide"
        />
      </div>
    </template>
    <template slot="default">
      <div class="m-modal-content">
        <form>
          <fieldset>
            <span class="name">公司名称：</span>
            <input
              type="text"
              placeholder="请输入公司名称"
              v-model="companyName"
            />
          </fieldset>
          <fieldset>
            <span class="name">擅长领域：</span>
            <input
              type="text"
              placeholder="请输入擅长领域"
              v-model="goodField"
            />
          </fieldset>
          <fieldset>
            <span class="name"> 所在城市：</span>
            <select
              name="province"
              id="province"
              @change="changeProvince"
              class="mr-3"
              v-model="provinceName"
            >
              <option value="" class="name" selected disabled>请选择省</option>
              <option
                :value="item"
                v-for="(item, index) in provinces"
                :key="index"
                >{{ item.province }}</option
              >
            </select>
            <select name="city" id="city" v-model="cityName">
              <option value="" class="name" selected disabled>请选择市</option>
              <option
                :value="item"
                v-for="(item, index) in cities"
                :key="index"
                >{{ item }}</option
              >
            </select>
          </fieldset>
          <fieldset>
            <span class="name">公司介绍：</span>
            <textarea
              name=""
              cols="30"
              rows="3"
              placeholder="请输入公司介绍"
              v-model="companyIntroduce"
            ></textarea>
          </fieldset>
          <fieldset>
            <span class="name">上传图片：</span>
            <div class="upload-img-block">
              <div class="item mr-4">
                <input
                  type="file"
                  ref="logoFile"
                  style="display: none;"
                  @change="handleLogoFileUpload"
                />
                <img
                  class="upload-img"
                  :src="logoFileThumb"
                  alt=""
                  @click="addLogoFile"
                  v-if="logoFileThumb"
                />
                <img
                  class="upload-img"
                  src="@/assets/images/icon_upload.png"
                  alt=""
                  @click="addLogoFile"
                  v-else
                />
                <button class="upload-button" @click.stop.prevent="addLogoFile">
                  上传LOGO
                </button>
              </div>
              <div class="item">
                <input
                  type="file"
                  ref="licenceFile"
                  style="display: none;"
                  @change="handleLicenceFileUpload"
                />
                <img
                  class="upload-img"
                  :src="licenceFileThumb"
                  alt=""
                  @click="addLicenceFile"
                  v-if="licenceFileThumb"
                />
                <img
                  class="upload-img"
                  src="@/assets/images/icon_upload.png"
                  alt=""
                  @click="addLicenceFile"
                  v-else
                />
                <button
                  class="upload-button"
                  @click.stop.prevent="addLicenceFile"
                >
                  上传营业执照
                </button>
              </div>
            </div>
          </fieldset>
        </form>
        <button class="confirm-button d-block mx-auto my-5" @click.stop="next">
          下一步
        </button>
      </div>
    </template>
  </b-modal>
</template>
<style lang="scss" scoped>
#auth-info-modal {
  width: 60%;
  .m-modal-header {
    width: 100%;
    display: flex;
    align-items: center;
    .top-title {
      flex: 1;
      font-size: 1.25rem;
      color: #333333;
      text-align: left;
      border-left: 0.19rem $acentColor solid;
      padding-left: 0.5rem;
    }
    .close-button {
      color: $acentColor;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .m-modal-content {
    form {
      fieldset {
        margin-bottom: 1rem;
        span.name,
        option.name {
          font-size: 1.13rem;
          color: #333333;
          vertical-align: top;
          display: inline-block;
          height: 2.38rem;
          display: inline-block;
        }
        input[type='text'],
        select,
        textarea {
          width: 80%;
          padding-left: 0.5rem;
          outline: none;
          border: solid 0.06rem #e5e5e5;
          resize: none;
          &::placeholder {
            font-size: 1.13rem;
            color: #999999;
          }
        }

        input[type='text'],
        select {
          height: 2.38rem;
        }
        select {
          width: 35%;
        }
        .upload-img-block {
          display: inline-block;
          width: 75%;
          .item {
            display: inline-block;
            .upload-img {
              margin-bottom: 0.8rem;
              width: 125px;
              height: 125px;
              object-fit: cover;
              cursor: pointer;
            }
            .upload-button {
              display: block;
              margin: 0 auto;
              padding: 0.4rem 0.5rem;
              background-color: white;
              border: solid 0.06rem $acentColor;
              color: $acentColor;
            }
          }
        }
      }
    }
    .confirm-button {
      font-size: 1.25rem;
      color: white;
      width: 60%;
      height: 2.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $acentColor;
      border: none;
      outline: none;
    }
  }
}
</style>

<script>
import area from '@/assets/data/area.json';
const { provinces } = area;
export default {
  data() {
    return {
      provinces: provinces,
      cities: [],
      companyName: '',
      goodField: '',
      cityName: '',
      provinceName: '',
      companyIntroduce: '',
      logoFile: '',
      logoFileThumb: '',
      licenceFile: '',
      licenceFileThumb: ''
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    next() {
      let info = {
        companyName: this.companyName,
        goodField: this.goodField,
        provinceName: this.provinceName,
        cityName: this.cityName,
        companyIntroduce: this.companyIntroduce,
        logoFile: this.logoFile,
        businessLicenseFile: this.businessLicenseFile
      };
      this.$emit('next', { info });
    },
    changeProvince(e) {
      const index = e.target.options.selectedIndex - 1;
      this.cities = this.provinces[index].cities;
    },
    addLogoFile() {
      this.$refs.logoFile.click();
    },
    handleLogoFileUpload() {
      this.logoFile = this.$refs.logoFile.files[0];
      console.log('logo file is ', this.logoFile);

      if (this.logoFile) {
        let reader = new FileReader();
        reader.readAsDataURL(this.logoFile);
        reader.onloadend = () => {
          this.logoFileThumb = reader.result;
          console.log('logo thumb is ', this.logoFileThumb);
        };
      }
    },
    addLicenceFile() {
      this.$refs.licenceFile.click();
    },
    handleLicenceFileUpload() {
      this.licenceFile = this.$refs.licenceFile.files[0];
      if (this.licenceFile) {
        let reader = new FileReader();
        reader.readAsDataURL(this.licenceFile);
        reader.onloadend = () => {
          this.licenceFileThumb = reader.result;
        };
      }
    }
  }
};
</script>
